import {DirectoryOrganization} from '@app/core/model/entity-profile';

export interface ISchoolYearRolloverSettings {
    [key: string]: SchoolYearRolloverModel;
}

export class SchoolYearRolloverModel {
    guid: string;
    orgGuid: string;
    settingsType: SchoolYearRolloverSettingsType;
    isEnabled: boolean;
    status: SchoolYearRolloverSettingsStatus;
    startDateTimestamp?: Date;
    endDateTimestamp?: Date;
    required: boolean;
    duration: number;
    overwrite: boolean;

    constructor(
        orgGuid: string = null,
        settingsType: SchoolYearRolloverSettingsType = null,
        isEnabled: boolean = null,
        startDateTimestamp: Date = null,
        endDateTimestamp: Date = null
    ) {
        this.orgGuid = orgGuid;
        this.settingsType = settingsType;
        this.isEnabled = isEnabled;
        this.startDateTimestamp = startDateTimestamp;
        this.endDateTimestamp = endDateTimestamp;
    }
}

export enum SchoolYearRolloverSettingsType {
    SuspendDataImport = 'SuspendDataImport',
    DisableDataDeletion = 'DisableDataDeletion'
}

export enum SchoolYearRolloverSettingsStatus {
    NOT_STARTED = 'NOT_STARTED',
    BEGAN = 'BEGAN',
    OVER = 'OVER'
}


export class SchoolYearRolloverTableDatasourceModel extends SchoolYearRolloverModel {
    orgGuid: string;
    orgName: string;
    org: DirectoryOrganization;
    [SchoolYearRolloverSettingsType.SuspendDataImport]: SchoolYearRolloverModel;
    [SchoolYearRolloverSettingsType.DisableDataDeletion]: SchoolYearRolloverModel;
    hasLMSIntegration: boolean;
    total: number;
    isOdd: boolean;
    index: number;

    constructor(
        orgGuid: string = null,
        orgName: string,
        org: DirectoryOrganization,
        hasLMSIntegration: boolean,
        total: number
    ) {
        super(orgGuid);
        this.orgGuid = orgGuid;
        this.orgName = orgName;
        this.org = org;
        this.hasLMSIntegration = hasLMSIntegration;
        this.total = total;
    }
}

export class DataRolloverSummaryDatasourceModel {
    constructor(public endDay: Date = null,
                public countOfDistricts: number = 0,
                public orgStatTotalCount: number = 0) {
    }
}
